export default {"src":"/_next/static/media/order-process-step3.a86f5326.svg","height":76,"width":76,"blurWidth":0,"blurHeight":0};